var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",style:(_vm.btnStyle),attrs:{"id":_vm.id,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loadingState)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.loadingState)?_c('div',{staticClass:"spinner spinner--1"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }